// ═══════════════════════════════════════════════════════════
// 全局常量 — 所有魔法数字的统一来源
// ═══════════════════════════════════════════════════════════

// ── 超时时间 (ms) ────────────────────────────────────────
export const TIMEOUT = {
    SITE_TEST: 8000,              // 站点可用性测试
    SEARCH: 15000,                // 搜索请求
    DETAIL: 15000,                // 详情请求
    FUNCTION_UPSTREAM: 12000,     // Cloudflare Function → CMS API
    LOADING_AUTO_DISMISS: 30000,  // Loading 自动关闭
    PLAYER_STALL_WARNING: 10000,  // 播放器加载过久提示
    TOAST_DISPLAY: 3000,          // Toast 显示时长
    TOAST_ANIMATION: 300,         // Toast 动画时长
};

// ── 缓存 TTL (ms) ─────────────────────────────────────────
export const CACHE_TTL = {
    SITE_STATUS: 5184000000,      // 60 天
    SEARCH_HISTORY: 5184000000,   // 60 天
};

// ── 数量限制 ──────────────────────────────────────────────
export const LIMITS = {
    SEARCH_HISTORY: 5,            // 搜索历史最多条数
    WATCH_HISTORY: 30,            // 观看历史最多条数
    SHOW_WATCH_HISTORY: 8,        // 首页展示的观看历史条数
    MAX_QUERY_LENGTH: 100,        // 搜索关键词最大长度
};

// ── localStorage Key ──────────────────────────────────────
export const STORAGE_KEYS = {
    API_SOURCE: 'libretv_api_source',
    CUSTOM_API_URL: 'libretv_custom_api_url',
    SEARCH_HISTORY: 'libretv_search_history',
    WATCH_HISTORY: 'libretv_watch_history',
    TV_MODE: 'libretv_tv_mode',
    SITE_STATUS_PREFIX: 'libretv_site_status_',
    PLAYER_STATE: 'libretv_player_state',
};

// ── 播放器配置 ────────────────────────────────────────────
export const PLAYER_CONFIG = {
    autoplay: true,
    allowFullscreen: true,
    width: '100%',
    height: '600',
    timeout: 15000,
    filterAds: true,
};

// ── HLS.js 配置 ───────────────────────────────────────────
export const HLS_CONFIG = {
    debug: false,
    enableWorker: true,
    lowLatencyMode: false,
    backBufferLength: 90,
    maxBufferLength: 30,
    maxMaxBufferLength: 60,
    maxBufferSize: 30 * 1000 * 1000,
    maxBufferHole: 0.5,
    fragLoadingMaxRetry: 6,
    fragLoadingMaxRetryTimeout: 64000,
    fragLoadingRetryDelay: 1000,
    manifestLoadingMaxRetry: 3,
    manifestLoadingRetryDelay: 1000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    startLevel: -1,
    abrEwmaDefaultEstimate: 500000,
    abrBandWidthFactor: 0.95,
    abrBandWidthUpFactor: 0.7,
    abrMaxWithRealBitrate: true,
    stretchShortVideoTrack: true,
    appendErrorMaxRetry: 5,
    liveSyncDurationCount: 3,
    liveDurationInfinity: false,
};

// ── Service Worker ────────────────────────────────────────
export const SW_CACHE_NAME = 'libretv-v3';
export const SW_CACHE_URLS = [
    '/',
    '/index.html',
    '/player.html',
    '/assets/app.js',
    '/assets/player.js',
    '/assets/styles.css',
    '/manifest.json',
    '/icon.svg',
];
